import { diff } from 'deep-object-diff';

export const isAllFieldsFilledUp = (object: object) => {
  const objectValues = Object.values(object);

  for (const value of objectValues) {
    if (!value) {
      return false;
    }
    if (typeof value === 'object' && !isAllFieldsFilledUp(value)) {
      return false;
    }
  }
  return true;
};

export function deepEqual(object1: Record<string, any>, object2: Record<string, any>) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false;
    }
  }
  return true;
}
export function isObject(object: unknown): object is object {
  return object != null && typeof object === 'object' && !Array.isArray(object);
}

export function jsonCopyObject(object: unknown) {
  return JSON.parse(JSON.stringify(object));
}

export const removeEmptyValuesFromObject = (object: object) =>
  Object.fromEntries(Object.entries(object).filter(([, value]) => value));

export const getCommonObject = (object1: object, object2: object) => {
  const differenceObject = diff(object1, object2);

  const unionEntries = Object.entries(object1).flatMap(([key, value]) => {
    if (!(key in differenceObject)) {
      return [[key, object1[key]]];
    }

    return [];
  });

  return Object.fromEntries(unionEntries);
};
